// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatZScore-module--root--1pOB0","right":"WhatZScore-module--right--3vk0j"};